export default __webpack_public_path__ + "static/revamping-central-reserve-system-for-a-sydeny-based-hosptiality-group-5e05dd096d01c285a07efc18897c0f9e.jpg";